'use strict';

var _ = require('lodash');
var MarketKpiRibbonAggregationFactory = function MarketKpiRibbonAggregationFactory(DataAggregationFactory) {
  function MarketKpiRibbonAggregation() {
    DataAggregationFactory.call(this, ['market', 'market-product-group', 'service'], 'kpi-ribbon');
  }
  MarketKpiRibbonAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  MarketKpiRibbonAggregation.constructor = MarketKpiRibbonAggregation;
  MarketKpiRibbonAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.targetType === targetType && this.sourceType.indexOf(sourceType) > -1;
  };
  MarketKpiRibbonAggregation.prototype.aggregate = function (data) {
    var reducedEntry = {
      resHoldTotalCurrent: undefined,
      resHoldTotalCurrentReference: undefined,
      resHoldTotalExpected: undefined,
      resHoldTotalFinalReference: undefined,
      revenueCurrent: undefined,
      revenueCurrentReference: undefined,
      revenueExpected: undefined,
      revenueFinalReference: undefined,
      revenuePaxDistanceCurrent: undefined,
      revenuePaxDistanceCurrentReference: undefined,
      revenuePaxDistanceExpected: undefined,
      revenuePaxDistanceFinalReference: undefined,
      yieldPlan: undefined,
      bookingsPlan: undefined,
      revenuePlan: undefined,
      unadjustedDemand: undefined,
      adjustedDemand: undefined,
      mwtpDemand: undefined
    };
    var avgFields = ['yieldPlan'];
    if (data.length === 0) {
      return reducedEntry;
    }
    var keys = Object.keys(reducedEntry);
    var calculatedFieldKeys = Object.keys(this.calculatedFields);
    var calculatedFieldProducts = {};
    for (var dataIndex = 0, dataLength = data.length; dataIndex < dataLength; dataIndex++) {
      var dataItem = data[dataIndex];

      // for summed/aggregated values
      for (var keysIndex = 0, keysLength = keys.length; keysIndex < keysLength; keysIndex++) {
        var value = dataItem[keys[keysIndex]];
        var aggregatedValue = reducedEntry[keys[keysIndex]];
        if (!_.isUndefined(value)) {
          reducedEntry[keys[keysIndex]] = (aggregatedValue ? aggregatedValue : 0) + value;
        }
      }

      // for calculated values
      for (var cfKeysIndex = 0, cfKeysLength = calculatedFieldKeys.length; cfKeysIndex < cfKeysLength; cfKeysIndex++) {
        var k = calculatedFieldKeys[cfKeysIndex];
        var v = this.calculatedFields[k];
        calculatedFieldProducts[k] = calculatedFieldProducts[k] || {};
        if (_.isNumber(dataItem[v.left]) && _.isNumber(dataItem[v.right])) {
          calculatedFieldProducts[k][v.left] = (calculatedFieldProducts[k][v.left] || 0) + dataItem[v.left];
          calculatedFieldProducts[k][v.right] = (calculatedFieldProducts[k][v.right] || 0) + dataItem[v.right];
        }
      }
    }
    _.forEach(this.calculatedFields, function (v, k) {
      var d = calculatedFieldProducts[k][v.right];
      var n = calculatedFieldProducts[k][v.left];
      reducedEntry[k] = d && _.isNumber(n) ? n / d : undefined;
    });
    _.forEach(avgFields, function (v) {
      reducedEntry[v] = reducedEntry[v] / data.length;
    });
    return reducedEntry;
  };
  return MarketKpiRibbonAggregation;
};
MarketKpiRibbonAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = MarketKpiRibbonAggregationFactory;